var _rect, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionInfo03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 9,
    fill: "#F5F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0049 32.0029C16.482 32.0029 12.0049 27.5258 12.0049 22.0029C12.0049 16.4801 16.482 12.0029 22.0049 12.0029C27.5277 12.0029 32.0049 16.4801 32.0049 22.0029C32.0049 27.5258 27.5277 32.0029 22.0049 32.0029ZM19.5049 19.0029L17.0049 21.5029L22.0041 26.5029L27.0049 21.5029L24.5049 19.0029H19.5049Z",
    fill: "url(#paint0_linear_1788_10330)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1788_10330",
    x1: 10.448,
    y1: 4.15981,
    x2: 55.9035,
    y2: 9.05034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F3AFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionInfo03);
export default __webpack_public_path__ + "static/media/subscription_info03.018b8687d6167b79ae1193f2e78e9a57.svg";
export { ForwardRef as ReactComponent };